import { alpha, darken, getContrastRatio, Theme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Theme { workspaceBrand?: string; }
  interface ThemeOptions { workspaceBrand?: string; }
}

/** Shared workspace colors derived from the active company palette. */
export function getWorkspaceTheme(theme: Theme) {
  const primary = theme.workspaceBrand || theme.palette.primary.main;
  let accent = primary;
  // Banners and selected navigation use white text, including with custom colors.
  for (let step = 0; step < 20 && getContrastRatio(accent, '#fff') < 4.5; step++) {
    accent = darken(accent, 0.1);
  }
  const dark = theme.palette.mode === 'dark';
  const sidebar = darken(primary, dark ? 0.86 : 0.76);
  return {
    accent,
    banner: `linear-gradient(120deg, ${accent}, ${darken(accent, 0.15)})`,
    bannerShadow: `0 8px 32px ${alpha(accent, dark ? 0.12 : 0.18)}`,
    sidebar,
    sidebarText: alpha('#fff', 0.88),
    sidebarMuted: alpha('#fff', 0.65),
    sidebarBorder: alpha('#fff', 0.12),
    sidebarHover: alpha('#fff', 0.08),
    selected: accent,
    selectedHover: darken(accent, 0.12),
    header: `linear-gradient(${alpha(primary, dark ? 0.12 : 0.045)}, ${alpha(primary, dark ? 0.12 : 0.045)}), linear-gradient(${theme.palette.background.paper}, ${theme.palette.background.paper})`,
    headerBorder: alpha(primary, dark ? 0.28 : 0.12),
    avatar: alpha(primary, dark ? 0.24 : 0.12),
    avatarText: dark ? theme.palette.text.primary : accent,
  };
}
